// The hub sections: home-page tiles, drawer entries and app-bar titles all derive
// from this single list so the three stay in sync.

import {
  Building2,
  ChartColumn,
  ReceiptText,
  ShoppingCart,
  Store,
  Wallet,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface HubSection {
  href: string;
  label: string;
  icon: LucideIcon;
  /** Colored icon circle on the home grid (light + dark). */
  tileClass: string;
  /** False → served by the shared ComingSoon page. */
  ready: boolean;
}

export const HUB_SECTIONS: HubSection[] = [
  {
    href: "/purchase-orders",
    label: "Purchase Order",
    icon: ShoppingCart,
    tileClass: "bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300",
    ready: false,
  },
  {
    href: "/requests",
    label: "Payment request",
    icon: ReceiptText,
    tileClass: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
    ready: true,
  },
  {
    href: "/budget",
    label: "Budget",
    icon: Wallet,
    tileClass: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300",
    ready: false,
  },
  {
    href: "/reports",
    label: "Report",
    icon: ChartColumn,
    tileClass: "bg-violet-100 text-violet-700 dark:bg-violet-950 dark:text-violet-300",
    ready: false,
  },
  {
    href: "/vendors",
    label: "Vendor",
    icon: Store,
    tileClass: "bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-300",
    ready: true,
  },
  {
    href: "/departments",
    label: "Departments",
    icon: Building2,
    tileClass: "bg-cyan-100 text-cyan-700 dark:bg-cyan-950 dark:text-cyan-300",
    ready: false,
  },
];

export const APP_NAME = "RGSEVA Payments";

interface SectionBar {
  title: string;
  /** Where the app-bar back arrow goes. */
  back: string;
}

/**
 * App-bar title + back target for the current route. `null` means the home hub
 * (app name, hamburger, no back arrow).
 */
export function sectionBar(pathname: string): SectionBar | null {
  if (pathname === "/") return null;
  if (pathname === "/requests") return { title: "Payment requests", back: "/" };
  if (pathname === "/requests/new") return { title: "New request", back: "/requests" };
  const editMatch = pathname.match(/^\/requests\/([^/]+)\/edit$/);
  if (editMatch) return { title: "Edit request", back: `/requests/${editMatch[1]}` };
  if (pathname.startsWith("/requests/")) return { title: "Request details", back: "/requests" };
  if (pathname === "/notifications") return { title: "Notifications", back: "/" };
  const section = HUB_SECTIONS.find((s) => pathname === s.href || pathname.startsWith(`${s.href}/`));
  if (section) return { title: section.label, back: "/" };
  return { title: APP_NAME, back: "/" };
}
